module.exports = __webpack_public_path__ + "static/media/thyroid.5bd4ac8c.png";